import React, { useState } from 'react';
import { AttachmentPreview } from '@/components/AttachmentPreview';
import { Paperclip } from '@/components/Icons/Paperclip';
import type { Attachment } from '@/types/attachment';
import { openAttachment } from '@/utils/attachments';

interface Props {
  attachment: Attachment;
  isFullWidth?: boolean;
  onPreview?: (attachment: Attachment) => void;
}

export const AttachmentChip: React.FC<Props> = ({
  attachment,
  isFullWidth = false,
  onPreview,
}) => {
  const [isPreviewOpen, setIsPreviewOpen] = useState(false);

  return (
    <>
      <button
        type="button"
        title={attachment.name}
        onClick={() =>
          openAttachment({
            attachment,
            onPreview: onPreview ?? (() => setIsPreviewOpen(true)),
          })
        }
        className={`flex max-w-full min-w-0 cursor-pointer items-center gap-2 rounded-[40px] bg-on-primary-surface px-2 py-1 transition-colors hover:bg-info-surface ${isFullWidth ? 'w-full' : 'w-fit'}`}
      >
        <Paperclip className="size-4 shrink-0 text-foreground" />
        <span className="truncate text-body-13 text-foreground">
          {attachment.name}
        </span>
      </button>

      {isPreviewOpen && (
        <AttachmentPreview
          attachment={attachment}
          onClose={() => setIsPreviewOpen(false)}
          onDownloaded={() => setIsPreviewOpen(false)}
        />
      )}
    </>
  );
};
